module.exports = __webpack_public_path__ + "static/media/homeIcon1.f76d420b.svg";